import React, { FC } from 'react';
import { Typography, Space, Button, Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { Form, BackButton } from '~/components';
import { useApplyForKycLevel, useKycPage } from '~/hooks/kyc';
import { SaveIcon } from '~/img';
import TransferTypeForm from '~/pages/beneficiaries/TransferTypeForm';
import { formWidth } from './utils';
import { BeneficiaryAccount } from '~/types';

const { Title, Text } = Typography;

const PayoutDetails: FC<any> = (props) => {
  const { className } = props;

  const [t] = useTranslation('kyc');

  const [form] = Form.useForm();
  const kycPage = useKycPage();

  // const addPayoutDetailsMutation = useAddPayoutDetails();
  const applyForKycLevelMutation = useApplyForKycLevel();

  const onFinish = async (values: { payoutDetails: BeneficiaryAccount }) => {
    // here we should create beneficiary and create account
    // await addPayoutDetailsMutation.mutateAsync(values.payoutDetails);
    const p = values.payoutDetails.parameters;
    let newName = values.payoutDetails.serviceName;
    if (p.accountNumber) {
      newName = `${newName} ${p.accountNumber.value}`;
    } else if (p.iban) {
      newName = `${newName} ${p.iban.value}`;
    }

    const result = {
      ...values.payoutDetails,
      name: newName,
    };
    await applyForKycLevelMutation.mutateAsync(result);
  };

  return (
    <Space direction="vertical" size="large" className={cx(className, 'Step-Container')}>
      <div>
        <Title level={3}>{t('Payout details')}</Title>
        <Text>{t('Input bank details for payouts.')}</Text>
      </div>
      <Form form={form} onFinish={onFinish} layout="vertical" style={formWidth}>
        <TransferTypeForm form={form} source={['payoutDetails']} />
        <Row gutter={16}>
          <Col>
            <BackButton onClick={kycPage.goBack} size="large" />
          </Col>
          <Col>
            <Form.Item noStyle>
              <Button
                type="primary"
                htmlType="submit"
                size="large"
                loading={applyForKycLevelMutation.isLoading}
                icon={<SaveIcon />}
              >
                {t('Finish')}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Space>
  );
};

export default PayoutDetails;
